import React from "react"
import MySalaryCertificatesTable from "../../Components/Tables/SalaryCertTables/MySalaryCertificatesTable"

export default function MySalaryCertificates() {
    return (
        <MySalaryCertificatesTable />
    )
}
